import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import profileImage from "../images/krishna.jpeg";

function Home() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/trades"); // Navigate to trades section
  };

  return (
    <div className="portfolio-container">
      <div className="profile-card">
        <img src={profileImage} alt="KrishnaKant Singht" className="profile-image" />
        <h1>KrishnaKant Singh</h1>
        <p className="contact">📞 9807740154</p>
        <p className="contact">📧 ks511658@gmail.com</p>
        <p className="intro">
          I am a professional trader and business strategist specializing in
          equity markets and disciplined capital management. With a data-driven
          approach and strong risk control principles, I focus on sustainable
          growth, strategic investments, and long-term wealth creation.
          My work blends market insight, analytical precision, and
          entrepreneurial vision.
        </p>


        <button className="trade-btn" onClick={handleNavigate}>
          My Trades
        </button>
      </div>
    </div>
  );
}

export default Home;
